import { Badge } from '@/components/ui/badge';
import { JobStatus } from '@recruitai/shared';

interface JobStatusBadgeProps {
  status: JobStatus;
}

export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  const variants = {
    [JobStatus.DRAFT]: { variant: 'secondary' as const, label: 'Rascunho' },
    [JobStatus.OPEN]: { variant: 'success' as const, label: 'Aberta' },
    [JobStatus.PAUSED]: { variant: 'outline' as const, label: 'Pausada' },
    [JobStatus.CLOSED]: { variant: 'destructive' as const, label: 'Fechada' },
  };

  const config = variants[status];

  return <Badge variant={config.variant}>{config.label}</Badge>;
}
